export const tableOption = {
  dialogDrag: true,
  border: true,
  indexLabel: '序号',
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  menuType: 'text',
  searchShow: false,
  excelBtn: false,
  printBtn: false,
  viewBtn: false,
  menu: false,
  emptyBtn: false,
  submitBtn: false,
  searchMenuSpan: 6,
  column: [
    //     {
    //     label: 'ID',
    //     prop: 'id',
    //     sortable: true,
    //     rules: [
    //             {
    //                 required: true,
    //                 message: '请输入ID',
    //                 trigger: 'blur'
    //             },
    //                             {
    //                 max: 36,
    //                 message: '长度在不能超过36个字符'
    //             },
    //         ]
    // },
    //     {
    //     label: '企业认证ID',
    //     prop: 'companyAuthId',
    //     sortable: true,
    //     rules: [
    //             {
    //                 required: true,
    //                 message: '请输入企业认证ID',
    //                 trigger: 'blur'
    //             },
    //                             {
    //                 max: 36,
    //                 message: '长度在不能超过36个字符'
    //             },
    //         ]
    // },
    {
      label: '角色名称',
      prop: 'positionName',
      sortable: true,
      row:true,
      showWordLimit:true,
      maxlength: 16,
      rules: [{
          required: true,
          message: '请输入角色名称',
          trigger: 'blur'
        },
        {
          max: 16,
          message: '长度在不能超过16个字符'
        },
      ]
    },
    {
      label: "角色描述",
      placeholder:"请对角色进行描述",
      showWordLimit:true,
      prop: "positionDesc",
      type: "textarea",
      maxlength: 60,
    },
    //     {
    //     label: '系统菜单IDS，多个以英文逗号分开',
    //     prop: 'systemMenuIds',
    //     sortable: true,
    //     rules: [
    //                         ]
    // },
    //     {
    //     label: '创建日期时间',
    //     prop: 'createDatetime',
    //     sortable: true,
    //     rules: [
    //             {
    //                 required: true,
    //                 message: '请输入创建日期时间',
    //                 trigger: 'blur'
    //             },
    //                         ]
    // },
    //     {
    //     label: '创建ID',
    //     prop: 'createId',
    //     sortable: true,
    //     rules: [
    //             {
    //                 required: true,
    //                 message: '请输入创建ID',
    //                 trigger: 'blur'
    //             },
    //                             {
    //                 max: 36,
    //                 message: '长度在不能超过36个字符'
    //             },
    //         ]
    // },
    //     {
    //     label: '修改日期时间',
    //     prop: 'updateDatetime',
    //     sortable: true,
    //     rules: [
    //             {
    //                 required: true,
    //                 message: '请输入修改日期时间',
    //                 trigger: 'blur'
    //             },
    //                         ]
    // },
    //     {
    //     label: '修改ID',
    //     prop: 'updateId',
    //     sortable: true,
    //     rules: [
    //             {
    //                 required: true,
    //                 message: '请输入修改ID',
    //                 trigger: 'blur'
    //             },
    //                             {
    //                 max: 36,
    //                 message: '长度在不能超过36个字符'
    //             },
    //         ]
    // },
  ]
}